import fbq from '../utils/facebook_pixel';

const value = $('[data-fb-amount]').data('fbAmount');
const currency = $('[data-fb-currency]').data('fbCurrency');

fbq('track', 'Purchase', { value, currency });
